﻿import { createApp } from "vue";
import { AppRoot } from "./AppRoot";
import { installClickTracking, trackPageView } from "./lib/analytics";
import "./styles.css";

const app = createApp(AppRoot);
app.mount("#app");
installClickTracking();
trackPageView("home");

if ("serviceWorker" in navigator) {
  void window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
